import validate from 'react-jsonschema-form/lib/validate';
import { mapValues } from 'lodash';

const validateForm = (data: any, schema: any) => {
  const { errorSchema } = validate(data, schema) as any;
  return mapValues(errorSchema, () => 'Invalid value');
};

export default validateForm;
